import cx from 'classnames';

interface Props {
  th: boolean;
  content: string | number;
  isBodyCell?: boolean;
}

export const Cell = ({ th, content, isBodyCell = false }: Props) => {
  if (th) {
    return (
      <th
        className={cx(
          'h-10 whitespace-nowrap border-2 border-transparent px-1 uppercase text-neutral-60 body-6 lg:min-w-[--matrixCellWidth]',
          {
            'w-[1%] pl-0': isBodyCell,
          },
        )}
      >
        {content}
      </th>
    );
  }

  return (
    <td className="h-[--matrixCellHeight] min-w-[--matrixCellWidth] border-2 border-transparent body-2">
      <div className="flex h-full items-center justify-center rounded-regular bg-neutral-96">{content}</div>
    </td>
  );
};
